import ApiService from './ApiService'

export async function apiSignIn (data) {
    // **JSR,...TODO: Here we need to authenticate user from /pw/auth/local
    // Enable code below to authenticate as partner User.
    return ApiService.fetchData({
        url: '/pw/auth/local',
        method: 'post',
        data: {
            pwUserIdentifier: data.identifier,
            pwUserSecret: data.password,
            pwPartnerId: data.partnerId
        }
    })
    // return ApiService.fetchData({
    //     url: '/auth/local',
    //     method: 'post',
    //     data
    // })
}
export async function apiSignInPartner (partnershortname) {
    return ApiService.fetchData({
        url: `/partners/get/${partnershortname}`,
        method: 'get'
    })
}


export async function apiSignOut (data) {
    return ApiService.fetchData({
        url: '/sign-out',
        method: 'post',
        data
    })
}

export async function apiForgotPassword (data) {
    return ApiService.fetchData({
        url: '/forgot-password',
        method: 'post',
        data
    })
}

export async function apiResetPassword (data) {
    return ApiService.fetchData({
        url: '/reset-password',
        method: 'post',
        data
    })
}
export async function apiChangePassword (data) {
    return ApiService.fetchData({
        url: '/auth/change-password',
        method: 'post',
        data
    })
}

export async function apiAskOtpResetPassword (data) {
    return ApiService.fetchData({
        url: `auth/reset-password-request`,
        method: 'post',
        data
    })
}

export async function apiVerifyOtpResetPassword (data) {
    return ApiService.fetchData({
        url: `auth/verify/reset-password-request`,
        method: 'post',
        data
    })
}

export async function apiGetFarmerPackageDetails (farmerPackageID) {
    return ApiService.fetchData({
        url: `/farmer-packages/${farmerPackageID}`, //need a costom url which will retun farmer package details
        method: 'get'
    })
}
